import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Communication } from '../../../../graphql/comms.datatypes';
import { updateCacheByType } from '../../../../graphql/GraphQlProvider';
import { gqlCommunication } from '../getCommunication.api';

interface DeleteCommunicationVars {
  id: number
}

interface DeleteCommunicationData {
  deleteCommunication: Communication
}

export const DELETE_COMMUNICATION_MUTATION = gql`
    mutation deleteCommunication($id: Int!) {
        deleteCommunication(id: $id) {
            ${gqlCommunication}
        }
    }
`;

export const deleteCommunication = () => useMutation<DeleteCommunicationData, DeleteCommunicationVars>(
  DELETE_COMMUNICATION_MUTATION,
  {
    update: updateCacheByType('Communication'),
  }
);

export default deleteCommunication;